var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLixeiraPreta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.444,
    height: 16,
    viewBox: "0 0 12.444 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 12.444,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.444,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.44444275 0l.8888855.88891602h3.1111145v1.777771H0v-1.777771h3.1111145L4 0h4.44444275zM.8888855 14.222229c.00292969.98059082.79715729 1.77484131 1.77777862 1.777771H9.777771c.98062133-.00292969 1.77485656-.79718018 1.77778625-1.777771V3.555542H.8888855v10.666687zM2.66666412 5.333313H9.777771V14.222229H2.66666412V5.333313z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixeiraPreta);
export default __webpack_public_path__ + "static/media/lixeira_preta.9e25d7d6a5773738c2b196658953ed1a.svg";
export { ForwardRef as ReactComponent };